import Select from "react-select";
import useLocalStorage from "../../Hooks/useLocalStorage";
import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  display: flex;
  border-bottom: 1px solid #dadde1;
  box-sizing: border-box;
  font-size: 1.5em;
  width: 100%;
  padding: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  /* padding: 1em; */
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 100%;
`;
const GraphicsPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  padding: 1em;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 100%;
`;

const Lineups = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  height: 100%;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const PeriodButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 80px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const HiddenButton = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 120px;
`;
const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
  width: 400px;
`;

const Tabs = styled.div`
  display: flex;
`;

const Tab = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  margin-right: 4px;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#181d25")};
`;

const SelectContainer = styled(Select)`
  min-width: 200px;
  margin-bottom: 0.5em;
  width: 90%;
`;

export default function SmartBarMain({
  previewGraphic,
  selectedGraphic,
  animateGraphic,
  animateOffGraphic,
  setSelectedGraphic,
  SmartBar,
  setSmartBar,
  selectedPlayer,
  game,
  setbarView,
  barview,
  homeKit,
  awayKit,
}) {
  const [SmartBar1, setSmartBar1] = useLocalStorage("SmartBar1", "");
  const [SmartBar2, setSmartBar2] = useLocalStorage("SmartBar2", "");
  const [SmartBar3, setSmartBar3] = useLocalStorage("SmartBar3", "");
  const [SmartBar4, setSmartBar4] = useLocalStorage("SmartBar4", "");
  const [savestate, setSavestate] = useLocalStorage("Savestate", "");

    let kit =
      selectedPlayer?.team?._id === game?.home_team?._id
        ? homeKit
        : awayKit;
  return (
    <div>
      <Row>
            <Tabs                 
                  style={{
                  marginTop: "10px",
                  alignItems: "center",
                }}>
            <Tab
              selected={barview === 0}
              onClick={() => {
                setbarView(0);
                let tabpush = { ...SmartBar};
                tabpush.contenttype = "0";
                setSmartBar(tabpush);
              }}
            >
              Headline Bar
            </Tab>
            <Tab
              selected={barview === 1}
              onClick={() => {
                setbarView(1);
                let tabpush = { ...SmartBar};
                tabpush.contenttype = "1";
                setSmartBar(tabpush);
              }}
            >
              Headline and Content
            </Tab>
            <Tab
              selected={barview === 2}
              onClick={() => {
                setbarView(2);
                let tabpush = { ...SmartBar};
                tabpush.contenttype = "2";
                setSmartBar(tabpush);
              }}
            >
              Stats Profile
            </Tab>
          </Tabs>
          <Tabs                 
                  style={{
                  marginTop: "10px",
                  alignItems: "center",
                  marginLeft: "100px"
                }}>
            <Tab
              selected={savestate === 1}
              onClick={() => {
                setSavestate(1);
              }}
            >
              Save
            </Tab>
            <Tab
              selected={savestate === 0}
              onClick={() => {
                setSavestate(0);
              }}
            >
              Load
            </Tab>
            <Tab
            style={{border: "1px solid " + SmartBar1?.kit}}
              onClick={() => {
                if (savestate === 1) {
                  setSmartBar1(SmartBar)
                } else {
                  setSmartBar(SmartBar1)
                  setbarView((parseInt(SmartBar1.contenttype)))
                }
              }}
            >
              Bar One {SmartBar1?.name}
            </Tab>
              <Tab
            style={{border: "1px solid " + SmartBar2?.kit}}
              onClick={() => {
                if (savestate === 1) {
                  setSmartBar2(SmartBar)
                } else {
                  setSmartBar(SmartBar2)
                  setbarView((parseInt(SmartBar2.contenttype)))
                }
              }}
            >
              Bar Two {SmartBar2?.name}
            </Tab>
            <Tab
            style={{border: "1px solid " + SmartBar3?.kit}}
              onClick={() => {
                if (savestate === 1) {
                  setSmartBar3(SmartBar)
                } else {
                  setSmartBar(SmartBar3)
                  setbarView((parseInt(SmartBar3.contenttype)))
                }
              }}
            >
              Bar Three {SmartBar3?.name}
            </Tab>
              <Tab
            style={{border: "1px solid " + SmartBar4?.kit}}
              onClick={() => {
                if (savestate === 1) {
                  setSmartBar4(SmartBar)
                } else {
                  setSmartBar(SmartBar4)
                  setbarView((parseInt(SmartBar4.contenttype)))
                }
              }}
            >
              Bar Four {SmartBar4?.name}
            </Tab>
          </Tabs>
          </Row>
          
          {barview === 0 && (
   <GraphicsPanel>
          <Column style={{ marginRight: "30px",
            textAlign: "center",}}>
                Bar Colour
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baroption = "team";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baroption === "team"}

                >
                  Team Colour
                </GraphicButton>
                                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baroption = "gen";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baroption === "gen"}

                >
                  Competition Colour
                </GraphicButton>
                </Row>
                Show Left Bar
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baromo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baromo === "show"}

                >
                  Show Bar
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baromo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baromo === "hide"}

                >
                  Hide Bar
                </GraphicButton>
                </Row>
                Show Team Badge
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.badgeomo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.badgeomo === "show"}

                >
                  Show Badge
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.badgeomo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.badgeomo === "hide"}

                >
                  Hide Badge
                </GraphicButton>
                </Row>
                Show Player Image
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.imageomo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.imageomo === "show"}

                >
                  Show Image
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.imageomo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.imageomo === "hide"}

                >
                  Hide Image
                </GraphicButton>
                </Row>

          </Column>
          <Column style={{ marginRight: "30px",}}>
                Headline / Name
                <Input
                  value={SmartBar?.name}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                Subline
                <Input
                  value={SmartBar?.subline}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.subline = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                Badge
                <Input
                  value={SmartBar?.hyper_badge}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.hyper_badge = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                Team Colour
                <Input
                  value={SmartBar?.kit}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.kit = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{border: "1px solid " + SmartBar.kit,}}
                />
                Player Image
                <Input
                  value={SmartBar?.image}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.image = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
              </Column>
              <Column>                
              <Row>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("SmartBar");
                    previewGraphic("SmartBar", {
                      game: game,
                      name: SmartBar?.name,
                      subline: SmartBar?.subline,
                      kit: SmartBar?.kit,
                      image: SmartBar?.image,
                      hyper_badge: SmartBar?.hyper_badge,
                      baroption: SmartBar?.baroption,
                      baromo: SmartBar?.baromo,
                      badgeomo: SmartBar?.badgeomo,
                      imageomo: SmartBar?.imageomo,
                      contenttype: SmartBar?.contenttype,
                      player: selectedPlayer,
                      subtext: selectedPlayer?.team?.name,
                      team: selectedPlayer?.team,
                    });
                  }}
                >
                  Smart Bar
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = `${selectedPlayer.first_name} ${selectedPlayer.last_name}`;
                    new_title_1.subline = selectedPlayer.team?.name;
                    new_title_1.image = selectedPlayer.image;
                    new_title_1.hyper_badge = selectedPlayer.team?.variables.hyper_badge;
                    new_title_1.kit = selectedPlayer.team?.variables?.[kit + "_kit_bg"];
                    setSmartBar(new_title_1);
                  }}
                >
                  Set Content as Player
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = "";
                    new_title_1.subline = "";
                    new_title_1.image = "";
                    new_title_1.hyper_badge = "";
                    new_title_1.kit = "";
                    setSmartBar(new_title_1);
                  }}
                >
                  Reset Content
                </GraphicButton>
                </Row>
                {selectedGraphic === "SmartBar" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("SmartBar");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("SmartBar");
                      }}
                    >
                      Out
                    </GraphicButton>
                    
                  </>
                )}
                </Column>
            </GraphicsPanel>
          )}
        {barview === 1 && (
        <GraphicsPanel>
          <Column style={{ marginRight: "30px",
            textAlign: "center",}}>
                Bar Colour
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baroption = "team";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baroption === "team"}

                >
                  Team Colour
                </GraphicButton>
                                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baroption = "gen";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baroption === "gen"}

                >
                  Competition Colour
                </GraphicButton>
                </Row>
                Show Left Bar
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baromo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baromo === "show"}

                >
                  Show Bar
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baromo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baromo === "hide"}

                >
                  Hide Bar
                </GraphicButton>
                </Row>
                Show Team Badge
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.badgeomo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.badgeomo === "show"}

                >
                  Show Badge
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.badgeomo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.badgeomo === "hide"}

                >
                  Hide Badge
                </GraphicButton>
                </Row>
                Show Player Image
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.imageomo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.imageomo === "show"}

                >
                  Show Image
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.imageomo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.imageomo === "hide"}

                >
                  Hide Image
                </GraphicButton>
                </Row>

          </Column>
          <Column style={{ marginRight: "30px", }}>
                Headline / Name
                <Input
                  value={SmartBar?.name}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                Subline
                <Input
                  value={SmartBar?.subline}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.subline = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                Badge
                <Input
                  value={SmartBar?.hyper_badge}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.hyper_badge = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                Team Colour
                <Input
                  value={SmartBar?.kit}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.kit = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{border: "1px solid " + SmartBar.kit,}}
                />
                Player Image
                <Input
                  value={SmartBar?.image}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.image = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                
              </Column>
              <Column style={{ marginRight: "30px",}}>
                Right Content
                <Input
                  value={SmartBar?.rightcontent}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.rightcontent = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                />
                <Row>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("SmartBar1");
                    previewGraphic("SmartBar", {
                      game: game,
                      name: SmartBar?.name,
                      subline: SmartBar?.subline,
                      kit: SmartBar?.kit,
                      image: SmartBar?.image,
                      hyper_badge: SmartBar?.hyper_badge,
                      rightcontent: SmartBar?.rightcontent,
                      baroption: SmartBar?.baroption,
                      baromo: SmartBar?.baromo,
                      badgeomo: SmartBar?.badgeomo,
                      imageomo: SmartBar?.imageomo,
                      contenttype: SmartBar?.contenttype,
                      player: selectedPlayer,
                      subtext: selectedPlayer?.team?.name,
                      team: selectedPlayer?.team,
                    });
                  }}
                >
                  Smart Bar
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = `${selectedPlayer.first_name} ${selectedPlayer.last_name}`;
                    new_title_1.subline = selectedPlayer.team?.name;
                    new_title_1.image = selectedPlayer.image;
                    new_title_1.hyper_badge = selectedPlayer.team?.variables.hyper_badge;
                    new_title_1.kit = selectedPlayer.team?.variables?.[kit + "_kit_bg"];
                    setSmartBar(new_title_1);
                  }}
                >
                  Set Content as Player
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = "";
                    new_title_1.subline = "";
                    new_title_1.image = "";
                    new_title_1.hyper_badge = "";
                    new_title_1.kit = "";
                    setSmartBar(new_title_1);
                  }}
                >
                  Reset Content
                </GraphicButton>
                </Row>
                {selectedGraphic === "SmartBar1" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("SmartBar");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("SmartBar");
                      }}
                    >
                      Out
                    </GraphicButton>
                    
                  </>
                )}
                </Column>
            </GraphicsPanel>
          )}
          {barview === 2 && (
        <GraphicsPanel>
          <Column style={{ marginRight: "30px", 
            textAlign: "center",}}>
                Bar Colour
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baroption = "team";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baroption === "team"}

                >
                  Team Colour
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baroption = "gen";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baroption === "gen"}

                >
                  Competition Colour
                </GraphicButton>
                </Row>
                Show Left Bar
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baromo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baromo === "show"}

                >
                  Show Bar
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.baromo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.baromo === "hide"}

                >
                  Hide Bar
                </GraphicButton>
                </Row>
                Show Team Badge
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.badgeomo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.badgeomo === "show"}

                >
                  Show Badge
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.badgeomo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.badgeomo === "hide"}

                >
                  Hide Badge
                </GraphicButton>
                </Row>
                Show Player Image
                <Row>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.imageomo = "show";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.imageomo === "show"}

                >
                  Show Image
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.imageomo = "hide";
                    setSmartBar(new_title_1);
                    }}
                    green= {
                        SmartBar?.imageomo === "hide"}

                >
                  Hide Image
                </GraphicButton>
                </Row>

          </Column>
          <Column style={{ marginRight: "30px", }}>
                Headline / Name
                <Input
                  value={SmartBar?.name}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Subline
                <Input
                  value={SmartBar?.subline}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.subline = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Badge
                <Input
                  value={SmartBar?.hyper_badge}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.hyper_badge = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Team Colour
                <Input
                  value={SmartBar?.kit}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.kit = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px",
                        border:
                        "1px solid " +
                        SmartBar.kit,
                  }}
                />
                Player Image
                <Input
                  value={SmartBar?.image}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.image = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                
              </Column>
              <Column style={{ marginRight: "30px",}}>
                Stat One Title
                <Input
                  value={SmartBar?.stat1title}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat1title = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Stat One Content
                <Input
                  value={SmartBar?.stat1content}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat1content = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                <Row
                style={{alignItems: "flex-start"}}>
                <Column>
                <GraphicButton
                style={{ marginRight: "0.25em",
                  marginLeft: "0em",
                }}
                  onClick={() => {
                    setSelectedGraphic("SmartBar2");
                    previewGraphic("SmartBar", {
                      game: game,
                      name: SmartBar?.name,
                      subline: SmartBar?.subline,
                      kit: SmartBar?.kit,
                      image: SmartBar?.image,
                      hyper_badge: SmartBar?.hyper_badge,
                      rightcontent: SmartBar?.rightcontent,
                      baroption: SmartBar?.baroption,
                      baromo: SmartBar?.baromo,
                      badgeomo: SmartBar?.badgeomo,
                      imageomo: SmartBar?.imageomo,
                      contenttype: SmartBar?.contenttype,
                      stat1title: SmartBar?.stat1title,
                      stat1content: SmartBar?.stat1content,
                      stat2title: SmartBar?.stat2title,
                      stat2content: SmartBar?.stat2content,
                      stat3title: SmartBar?.stat3title,
                      stat3content: SmartBar?.stat3content,
                      stat4title: SmartBar?.stat4title,
                      stat4content: SmartBar?.stat4content,
                      player: selectedPlayer,
                      subtext: selectedPlayer?.team?.name,
                      team: selectedPlayer?.team,
                    });
                  }}
                >
                  Smart Bar
                </GraphicButton>
                {selectedGraphic === "SmartBar2" && (
                  <>
                    <GraphicButton
                  style={{ marginRight: "0.25em",
                  marginLeft: "0em",}}
                      green
                      onClick={() => {
                        animateGraphic("SmartBar");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                    style={{ marginRight: "0.25em",
                    marginLeft: "0em",}}
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("SmartBar");
                      }}
                    >
                      Out
                    </GraphicButton>
                    
                  </>
                )}
                </Column>
                <Column>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = `${selectedPlayer.first_name} ${selectedPlayer.last_name}`;
                    new_title_1.subline = selectedPlayer.team?.name;
                    new_title_1.image = selectedPlayer.image;
                    new_title_1.hyper_badge = selectedPlayer.team?.variables.hyper_badge;
                    new_title_1.kit = selectedPlayer.team?.variables?.[kit + "_kit_bg"];
                    setSmartBar(new_title_1);
                  }}
                >
                  Set Content as Player
                </GraphicButton>
                <GraphicButton
                  onClick={() => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.name = "";
                    new_title_1.subline = "";
                    new_title_1.image = "";
                    new_title_1.hyper_badge = "";
                    new_title_1.kit = "";
                    setSmartBar(new_title_1);
                  }}
                >
                  Reset Content
                </GraphicButton>
                </Column>
                </Row>
            </Column>
            <Column style={{ marginRight: "30px", }}>
                Stat Two Title
                <Input
                  value={SmartBar?.stat2title}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat2title = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Stat Two Content
                <Input
                  value={SmartBar?.stat2content}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat2content = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                </Column>
                <Column style={{ marginRight: "30px", }}>
                Stat Three Title
                <Input
                  value={SmartBar?.stat3title}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat3title = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Stat Three Content
                <Input
                  value={SmartBar?.stat3content}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat3content = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                </Column>
                <Column style={{ marginRight: "30px", }}>
                Stat Four Title
                <Input
                  value={SmartBar?.stat4title}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat4title = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                Stat Four Content
                <Input
                  value={SmartBar?.stat4content}
                  onChange={(e) => {
                    let new_title_1 = { ...SmartBar };
                    new_title_1.stat4content = e.currentTarget.value;
                    setSmartBar(new_title_1);
                  }}
                  style={{ width: "250px"}}
                />
                </Column>
            </GraphicsPanel>
          )}
          </div>
)}